import request from '../axiosInterceptor'

const api = {
  getWhatsappGroupDetails(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/whatsapp-group/companion-details`,
      method: 'get',
    })
  },
  getGroupDetailsById(id: any, key: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/whatsapp-group/companion-details-by-unique-key?unique_key=${key}`,
      method: 'get',
    })
  },
  postAddEditGroup(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/whatsapp-group/activate-or-edit-companion`,
      method: 'post',
      data: data,
    })
  },
  getAllWhatsappGroups(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/whatsapp-group/get-private-groups`,
      method: 'get',
    })
  },
  getAllTasks(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/incidents/incidents-list`,
      method: 'get',
    })
  },
  getAllObservation(
    id: any,
    filters?: {
      from_date?: string
      to_date?: string
    },
  ) {
    const params = new URLSearchParams()
    if (filters?.from_date) params.set('from_date', filters.from_date)
    if (filters?.to_date) params.set('to_date', filters.to_date)
    const qs = params.toString()
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/observations/observations-list${qs ? `?${qs}` : ''}`,
      method: 'get',
    })
  },
  getAllLinkedObservation(id: any,subsidiaryId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/observations/observations-list?project_details_id=${id}&subsidiary_master_id=${subsidiaryId}`,
      method: 'get',
    })
  },
  getInspectionsSchedules(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/inspection-schedule-list`,
      method: 'get',
    })
  },
  getInspectionsScheduleById(id: any, scheduleId: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/inspection-schedule?schedule_id=${scheduleId}`,
      method: 'get',
    })
  },
  getInspections(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/list-inspection`,
      method: 'get',
    })
  },
  getNonConformance(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/non-conformance-list`,
      method: 'get',
    })
  },
  getInspectionTopic() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/inspection-topic`,
      method: 'get',
    })
  },
  getAllIncidents(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/incidents/incidents-list`,
      method: 'get',
    })
  },
  getAllLinkedIncidents(id: any,subsidiaryId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/incidents/incidents-list?project_details_id=${id}&subsidiary_master_id=${subsidiaryId}`,
      method: 'get',
    })
  },
  getIncidentDetails(pId: any, id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/incidents/incident-details-by-incident-id?incident_details_id=${id}`,
      method: 'get',
    })
  },
  getLinkedIncidentDetails(pId: any, id: any,subsidiaryId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/incidents/incident-details-by-incident-id?project_details_id=${pId}&subsidiary_master_id=${subsidiaryId}&incident_details_id=${id}`,
      method: 'get',
    })
  },
  putUploadIncidentFile(pId: any, id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/incidents/upload?incident_id=${id}`,
      method: 'put',
      data: data,
    })
  },
  getNonConformanceDetails(pId: any, id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/inspections/inspection-non-conformance?inspection_id=${id}`,
      method: 'get',
    })
  },
  getNonConformanceDetailsByNonConfId(pId: any, id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/inspections/non-conformance-details?nc_id=${id}`,
      method: 'get',
    })
  },
  getInspectionsDetails(pId: any, id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/inspections/details-inspection?inspection_id=${id}`,
      method: 'get',
    })
  },

  getIncidentsColumns(pId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences?slug_name=incidents/incidents-list`,
      method: 'get',
    })
  },

  getObservationColumns(pId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences?slug_name=observations/observations-list`,
      method: 'get',
    })
  },

  updateColumnConfig(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences`,
      method: 'post',
      data: data,
    })
  },

  getObservationDetails(pId: any, id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/observations/observation-detail?observation_details_id=${id}`,
      method: 'get',
    })
  },
  getLinkedObservationDetails(pId: any, id: any,subsidiaryId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/observations/observation-detail?project_details_id=${pId}&subsidiary_master_id=${subsidiaryId}&observation_details_id=${id}`,
      method: 'get',
    })
  },
  getExportIncident(pId: any, format: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/incidents/incidents-list-export?file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  getExportIncidentView(pId: any, format: string,subsidiaryId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/incidents/incidents-list-export?project_details_id=${pId}&subsidiary_master_id=${subsidiaryId}&file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  getExportTraining(pId: any, format: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/training/training-list-export?file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  getExportTrainingView(pId: any, format: string,subsidiaryId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/training/training-list-export?project_details_id=${pId}&subsidiary_master_id=${subsidiaryId}&file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  postHscHandle(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${data?.pId}/observations/hse-status`,
      method: 'post',
      data: data,
    })
  },
  postExportIncidentPDF(pId: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/incidents/get-incident-detail-by-incident-id-export`,
      method: 'post',
      data: data,
    })
  },
  postExportIncidentPDFView(pId: any, subsidiaryId: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/incidents/get-incident-detail-by-incident-id-export?project_details_id=${pId}&subsidiary_master_id=${subsidiaryId}&report_type=${data?.report_type}&incident_id=${data?.incident_id}`,
      method: 'get',
      data: data,
    })
  },
  putUpdateIncident(pId: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/incidents/update`,
      method: 'put',
      data: data,
    })
  },
  postObservationRecordType(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${data?.pId}/observations/update`,
      method: 'post',
      data: data,
    })
  },
  postIncidentHsc(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${data?.pId}/incidents/hse-status`,
      method: 'post',
      data: data?.form,
    })
  },
  postIncidentUpdate(id: string, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/incident/update`,
      method: 'post',
      data: data,
    })
  },
  postNonConformanceHSE(pId: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/inspections/non-conformance/hse-status`,
      method: 'post',
      data: data,
    })
  },
  postAddInspectionSchedule(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/add-inspection-schedule`,
      method: 'post',
      data: data,
    })
  },
  postEditInspectionSchedule(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/edit-inspection-schedule-details`,
      method: 'post',
      data: data,
    })
  },
  postUpdateNonConformancePopup(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/add-inspection-non-conformance`,
      method: 'post',
      data: data,
    })
  },
  getExportInspectionSchedule(id: any, format: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/schedule-list-export?file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  getExportInspections(id: any, format: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/inspection-list-export?file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  getExportInspectionsNonConformance(id: any, format: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/inspections/non-conformance-list-export?file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  getExportRecentQueries(copilotIndex: any, format: string, platform: any, fromDate?: any, toDate?: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-hub/${copilotIndex}/dashboard-recent-query-export?platform=${platform}&file_format=${format}${fromDate && toDate ? `&from_date=${fromDate}&to_date=${toDate}` : ''}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  getAllTrainings(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/training/trainings-list`,
      method: 'get',
    })
  },

  getTrainingsColumns(pId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences?slug_name=training/trainings-list`,
      method: 'get',
    })
  },
  getInspectionsColumns(pId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences?slug_name=inspections/list-inspection`,
      method: 'get',
    })
  },
  getInspectionsScheduleColumns(pId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences?slug_name=inspections/inspection-schedule-list`,
      method: 'get',
    })
  },
  getRulesAndEscalationColumns(pId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences?slug_name=rules-escalation/list`,
      method: 'get',
    })
  },

  getScheculeColumns(pId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences?slug_name=statistics-capture/statistic-capture-schedule-list`,
      method: 'get',
    })
  },

  getStatisticsCaptureReportColumns(pId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences?slug_name=statistics-capture/statistic-capture-report-list`,
      method: 'get',
    })
  },

  getInspectionsNonConformanceColumns(pId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/user/preferences?slug_name=inspections/non-conformance-list`,
      method: 'get',
    })
  },
  getAllLinkedTrainings(id: any,subsidiaryId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/training/trainings-list?project_details_id=${id}&subsidiary_master_id=${subsidiaryId}`,
      method: 'get',
    })
  },
  getTrainingDetails(pId: any, id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/training/details/${id}`,
      method: 'get',
    })
  },
  getLinkedTrainingDetails(pId: any, id: any,subsidiaryId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/training/details/${id}?subsidiary_master_id=${subsidiaryId}`,
      method: 'get',
    })
  },
}

export default api
